import {Component, OnInit, ViewChild} from '@angular/core';
import {GeneralService} from "../../../../services/generalService";
import {RouteService} from "../../../../services/routeService";
import {NotificationService} from "../../../../services/notificationService";
import {CollaborationProtectionService} from "../../../../services/collaborationProtectionService";
import {DICTIONARY} from "../../../../dictionary";
import {TrustifiTableComponent} from "../../../uiComponents/trustifi-table/trustifi-table.component";
import _ from 'lodash';


@Component({
	selector: 'app-collaboration-resources',
	templateUrl: './collaboration-resources.component.html'
})
export class CollaborationResourcesComponent implements OnInit {

	@ViewChild('resourcesTableEl') resourcesTableEl : TrustifiTableComponent;

	constructor(private gs:GeneralService,
				private rs:RouteService,
				private ns:NotificationService,
				private cps:CollaborationProtectionService) {
	}

	_ = _;
	dic = DICTIONARY;
	filterData;
	collaborationResources;
	assetsByResource: Record<string, any[]> = {};
	loadingInProcess;
	presetFilter;
	currentResourceAssetsPopup;
	currentAssetInfoObj;

	linkScopeTooltips: Record<string, string> = {
		anonymous: 'Anyone with the link can access (no login required)',
		organization: 'All users in your company can access (must sign in)',
		users: 'Only users with existing access (must sign in)',
		external: 'At least one or more external user has an access to this file'
	};

	ngOnInit() {
		if (window.history.state?.data) {
			this.presetFilter = window.history.state.data;
		}

		this.initFilters();

		Promise.all([this.getCollaborationResources(), this.getCollaborationAssets()]).then(() => {
			this.collaborationResources.forEach(resourceObj => {
				resourceObj.assets = this.assetsByResource[resourceObj._id] || [];
				this.parseResourceFindings(resourceObj);
			});
		});
	}

	getCollaborationResources = () => {
		this.loadingInProcess = true;
		return this.rs.getCollaborationResources().then((response) => {
			this.collaborationResources = response || [];
			this.collaborationResources.forEach((resourceObj) => {
				this.cps.parseResourceName(resourceObj);

				if (this.assetsByResource) {
					resourceObj.assets = this.assetsByResource[resourceObj._id] || [];
					this.parseResourceFindings(resourceObj);
				}
			});

			// Apply preset filters from overview navigation (deferred to run after table init)
			if (this.presetFilter && this.resourcesTableEl) {
				setTimeout(() => {
					this.resourcesTableEl.search.text = this.presetFilter.search || '';
					let updateFilterData = [];
					if (this.presetFilter.filters?.length) {
						updateFilterData = this.presetFilter.filters;
						this.resourcesTableEl.updateFilterOptions(updateFilterData);
					}
					else if (this.resourcesTableEl.search) {
						this.resourcesTableEl.searchItem();
					}

					this.presetFilter = null;
				});
			}

			this.loadingInProcess = false;
		}, (err) => {
			this.loadingInProcess = false;
		});
	}

	getCollaborationAssets = () => {
		return this.rs.getCollaborationAssets().then((response) => {
			const assets = response;
			assets.forEach((assetObj) => {
				this.cps.parseResourceName(assetObj.resource_id);
				this.parseAssetDetails(assetObj);
			});

			this.assetsByResource = _.groupBy(assets, (assetObj) => assetObj.resource_id?._id);
		}, (err) => {
		});
	}

	parseAssetDetails = (assetObj) => {
		if (assetObj.sensitivity_info) {
			assetObj._topSensitiveTypes = (assetObj.sensitivity_info.sensitive_types || [])
				.filter(t => t.score)
				.sort((a, b) => (b.score || 0) - (a.score || 0))
				.slice(0, 3)
				.map(t => t.sensitive_type);
		}

		if (assetObj.malicious_info) {
			assetObj._maliciousSubCategory = (assetObj.malicious_info.sub_status || [])
				.map(s => s.message)
				.slice(0, 2);
		}
	}

	parseResourceFindings = (resourceObj) => {
		const assets = resourceObj.assets || [];
		const maliciousAssets = assets.filter(a => a.category === 'Malicious');
		const dlpAssets = assets.filter(a => a.category === 'DLP');
		resourceObj._findings = {
			maliciousCount: maliciousAssets.length,
			dlpCount: dlpAssets.length,
			topMaliciousStatus: maliciousAssets[0]?.malicious_info?.status || 'Malicious',
			topDlpScore: dlpAssets.length ? Math.max(...dlpAssets.map(a => a.sensitivity_info?.score ?? 0)) : 0,
		};
	}

	initFilters = () => {
		const filters = {
			type: [this.dic.CONSTANTS.collaborationResourceType.chat, this.dic.CONSTANTS.collaborationResourceType.meeting,
				this.dic.CONSTANTS.collaborationResourceType.channel, 'OneDrive'
				, this.dic.CONSTANTS.collaborationResourceType.team, this.dic.CONSTANTS.collaborationResourceType.site],
			permissions: ['anonymous', 'organization', 'users'],
		};

		this.filterData = {
			filterType: this.dic.CONSTANTS.tableFilters.collaborationResources,
			filters: filters,
			initFiltersFunction: this.initFilters,
		};
	};

	showResourceMultipleActions = () => {
		return [
			'Delete',
		];
	};


	selectResourceMultipleAction = (selectedItems, action) => {
		switch (action) {
			case 'Delete':
				this.deleteResources(selectedItems);
				break;
		}
	};

	showAssetActionsInPopup = (assetObj) => {
		return ['View info'];
	}

	selectAssetActionInPopup = (assetObj, action) => {
		switch (action) {
			case 'View info':
				this.currentAssetInfoObj = assetObj;
				break;
		}
	}

	showResourceActions = (resourceObj) => {
		return [
			'Show Assets',
			'Delete',
		];
	}

	selectResourceAction =  (resourceObj, action) => {
		if (!resourceObj) {
			return;
		}

		switch (action) {
			case 'Show Assets':
				this.currentResourceAssetsPopup = resourceObj;
				break;

			case 'Delete':
				this.deleteResources([resourceObj]);
				break;
		}
	}

	deleteResources = (resources) => {
		this.gs.showPopup({
			title: `Delete Resource`,
			subTitle: resources.length > 1 ? `You are about to delete ${resources.length} resources` : `You are about to delete resource`,
			type: this.dic.CONSTANTS.popupWarning,
			doneBtnText: 'Delete',
			doneCb: () => {
				resources.forEach((resourceObj) => {
					this.rs.deleteCollaborationResource(resourceObj.id).then((response) => {
						this.collaborationResources = this.collaborationResources.filter(m => m.id !== resourceObj.id);
						this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
					}, (err) => {
					});
				});
			}
		});
	}

	searchResources = (searchTerm, activeFilters) => {
		this.collaborationResources.forEach(record => {
			if (searchTerm) {
				const isFound = searchTextExecute(record, searchTerm);
				if (!isFound) {
					record.hide = true;
					return;
				}
			}

			// filter
			if (activeFilters) {
				let numFilterToMatch = Object.keys(activeFilters).length;

				if (activeFilters['type']?.length) {
					if (activeFilters['type'].includes(record.resource_type) || activeFilters['type'].includes(record.resource_sub_type)) {
						numFilterToMatch--;
					}
				}

				if (activeFilters['permissions']?.length) {
					if (record.assets?.length) {
						if (record.assets.find(asset => activeFilters['permissions'].includes(asset.permissions?.link?.scope))) {
							numFilterToMatch--;
						}
					}
				}

				if (numFilterToMatch) {
					record.hide = true;
					return;
				}
			}

			record.hide = false;
		});
	}

	sensitivityScoreColor(score: number) {
		if (score >= 5) return '#FF4136';
		if (score >= 4) return '#FF851B';
		if (score >= 1) return 'darkorange';
		return 'limegreen';
	}

	exportToCsv = (sortBy) => {
		if (!this.collaborationResources?.length) {
			this.ns.showWarnMessage(this.dic.ERRORS.noDataToExportCsv);
			return;
		}
		let csvString = 'Name,Type,Members,External Members,Findings,Last Activity\n';
		let rows = this.collaborationResources.filter(e => !e.hide);
		if (sortBy) {
			rows = this.gs.sortTable(rows, sortBy);
		}
		rows.forEach(itm => {
			const findings = itm._category?.type === 'DLP' ? `DLP (score: ${itm._category.score})` : itm._category?.type || '';
			csvString += `${itm.name},${itm.resource_type},"${itm.members.join(', ')}","${itm.external_members?.join(', ')}",${findings},${itm.last_updated}\n`;
		});
		this.gs.exportCsv(csvString, 'collab_resources.csv');
	}
}

function searchTextExecute(userObj, searchTerm) {
	searchTerm = searchTerm.toLowerCase();
	return (userObj.email?.toLowerCase().indexOf(searchTerm) > -1 ||
		userObj.name?.toLowerCase().indexOf(searchTerm) > -1 ||
		userObj.id?.toLowerCase().indexOf(searchTerm) > -1 ||
		userObj.resource_type?.toLowerCase().indexOf(searchTerm) > -1 ||
		userObj.members?.join(',')?.toLowerCase().indexOf(searchTerm) > -1);
}
